import React from 'react';
import { connect } from 'react-redux';
import { MenuItemLink, getResources } from 'react-admin';
import { withRouter } from 'react-router-dom';
import UserIcon from '@material-ui/icons/Group';
import DashboardIcon from '@material-ui/icons/Dashboard';
import CityIcon from '@material-ui/icons/LocationCity';
import OrderIcon from '@material-ui/icons/Business';
import RestaurantIcon from '@material-ui/icons/Restaurant';
import RestaurantMenuIcon from '@material-ui/icons/RestaurantMenu';
import FoodCategoryIcon from '@material-ui/icons/Fastfood';
import FeedbackIcon from '@material-ui/icons/Feedback';
import CouponIcon from '@material-ui/icons/LocalOffer';
import AppUsersIcon from '@material-ui/icons/SupervisedUserCircle';

const adminMenus = onMenuTap => [
    <MenuItemLink to="/" primaryText="Dashboard" onClick={onMenuTap} key={1} leftIcon={<DashboardIcon />} exact />,
    <MenuItemLink to="/app-users" primaryText="App Users" onClick={onMenuTap} key={2} leftIcon={<AppUsersIcon />} exact />,
    <MenuItemLink to="/cities" primaryText="Cities" onClick={onMenuTap} key={3} leftIcon={<CityIcon />} />,
    <MenuItemLink to="/city-admin-users" primaryText="City-Admins" onClick={onMenuTap} key={4} leftIcon={<UserIcon />} />,
    <MenuItemLink to="/feedbacks" primaryText="App Feedback" onClick={onMenuTap} key={5} leftIcon={<FeedbackIcon />} />
];

const clearIfMerchant = () => {
    if (sessionStorage.getItem('merchantId')) {
        sessionStorage.removeItem("merchantId");
        sessionStorage.removeItem("merchantUrl");
        sessionStorage.removeItem("merchantName");
    }
}

const cityMerchantMenus = onMenuTap => [
    <MenuItemLink to="/" primaryText="Dashboard" onClick={() => {
        clearIfMerchant();
        return onMenuTap;
    }} key={1} leftIcon={<DashboardIcon />} exact />,

    <MenuItemLink to="/ct/orders" primaryText="Orders" onClick={() => {
        clearIfMerchant();
        return onMenuTap;
    }} key={5} leftIcon={<OrderIcon />} />,
    <MenuItemLink to="/app-users" primaryText="App Users" onClick={() => {
        clearIfMerchant();
        return onMenuTap;
    }} key={6} leftIcon={<UserIcon />} />,
    <MenuItemLink to="/feedbacks" primaryText="App Feedback" onClick={() => {
        clearIfMerchant();
        return onMenuTap;
    }} key={7} leftIcon={<FeedbackIcon />} />,
    <MenuItemLink to="/coupons" primaryText="Coupons" onClick={() => {
        clearIfMerchant();
        return onMenuTap;
    }} key={9} leftIcon={<CouponIcon />} />,
    <MenuItemLink to="/ct/merchants" primaryText="Restaurants" onClick={() => {
        clearIfMerchant();
        return onMenuTap;
    }} key={2} leftIcon={<RestaurantIcon />} />,
    <MenuItemLink to="/mrcht/categories" primaryText="Categories" onClick={onMenuTap} key={3} leftIcon={<FoodCategoryIcon />} />,
    <MenuItemLink to="/mrcht/products" primaryText="Products" onClick={onMenuTap} key={4} leftIcon={<RestaurantMenuIcon />} />,
    <MenuItemLink to="/mrcht/users" primaryText="Merchant Admins" onClick={onMenuTap} key={8} leftIcon={<UserIcon />} />
];

const cityMenus = onMenuTap => [
    <MenuItemLink to="/" primaryText="Dashboard" onClick={onMenuTap} key={1} leftIcon={<DashboardIcon />} exact />,
    <MenuItemLink to="/ct/orders" primaryText="Orders" onClick={onMenuTap} key={5} leftIcon={<OrderIcon />} />,
    <MenuItemLink to="/app-users" primaryText="App Users" onClick={onMenuTap} key={6} leftIcon={<UserIcon />} />,
    <MenuItemLink to="/feedbacks" primaryText="App Feedback" onClick={onMenuTap} key={7} leftIcon={<FeedbackIcon />} />,
    <MenuItemLink to="/coupons" primaryText="Coupons" onClick={onMenuTap} key={8} leftIcon={<CouponIcon />} />,
    <MenuItemLink to="/ct/merchants" primaryText="Restaurants" onClick={onMenuTap} key={2} leftIcon={<RestaurantIcon />} />,
];

const merchantMenus = onMenuTap => [
    <MenuItemLink to="/" primaryText="Dashboard" onClick={onMenuTap} key={1} leftIcon={<DashboardIcon />} exact />,
    <MenuItemLink to="/mrcht/orders" primaryText="Orders" onClick={onMenuTap} key={5} leftIcon={<OrderIcon />} />,
    <MenuItemLink to="/mrcht/categories" primaryText="Categories" onClick={onMenuTap} key={3} leftIcon={<FoodCategoryIcon />} />,
    <MenuItemLink to="/mrcht/products" primaryText="Products" onClick={onMenuTap} key={4} leftIcon={<RestaurantMenuIcon />} />,
];

const otherMenus = onMenuTap => [
    // <MenuItemLink to="/" primaryText="Dashboard" onClick={onMenuTap} key={1} leftIcon={<DashboardIcon />} exact />,
    // <MenuItemLink to="/htl/guests" primaryText="Guests" onClick={onMenuTap} key={3} leftIcon={<GuestIcon />} />,
    // <MenuItemLink to="/htl/bookings" primaryText="Bookings" onClick={onMenuTap} key={4} leftIcon={<Bookings />} />,
    // <MenuItemLink to="/htl/housekeepings" primaryText="Housekeeping" onClick={onMenuTap} key={5} leftIcon={<Housekeeping />} />
];

const getMenus = (onMenuTap) => {
    switch (atob(sessionStorage.getItem("zutp"))) {
        case "SA":
            return adminMenus(onMenuTap);

        case "CA":
            if (sessionStorage.getItem('merchantId') !== null) {
                return cityMerchantMenus(onMenuTap);
            }
            return cityMenus(onMenuTap);

        case "MA":
            return merchantMenus(onMenuTap);

        default:
            return otherMenus(onMenuTap);
    }
};

const Menu = ({ resources, onMenuClick, logout }) => (
    <div>
        {getMenus(onMenuClick)}
    </div>
);

const mapStateToProps = state => ({
    resources: getResources(state),
});

export default withRouter(connect(mapStateToProps)(Menu));
